import { TFunc } from '@Translations/types';
import * as yup from 'yup';

const nameSchema = (t: TFunc) =>
	yup
		.string()
		.trim('The contact name cannot include leading and trailing spaces')
		.required(t('Name is required'))
		.min(5, t('Name must be at least 5 characters'))
		.max(50, t('Name must be at most 50 characters'));
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const descriptionSchema = (t: TFunc) =>
	yup
		.string()
		.nullable(true)
		.optional()
		.max(400, t('Description must be at most 400 characters'));

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const syncSettingsSchema = (t: TFunc) => yup.string().nullable(true);

const VaparSettingsShape = (t: TFunc) => ({
	name: nameSchema(t),
	description: descriptionSchema(t),
	syncSettings: syncSettingsSchema(t),
});

export const VaparSettingsSchema = (t: TFunc) =>
	yup.object().shape(VaparSettingsShape(t), [['sensors', 'sensorGroups']]);
